import { createElement } from 'react';
import {
  DEFAULT_WEATHER_DETAIL_ICON_SIZE,
  WEATHER_DETAIL_ICON_COMPONENTS,
} from '../config/weatherDetailIcons.config';

export const getDetailIcon = (detail, data, iconProps = {}) => {
  const IconComponent = WEATHER_DETAIL_ICON_COMPONENTS[detail?.iconKey];
  if (!IconComponent) return null;

  const configuredIconProps = detail.getIconProps?.(data) ?? {};

  return createElement(IconComponent, {
    size: DEFAULT_WEATHER_DETAIL_ICON_SIZE,
    ...configuredIconProps,
    ...iconProps,
  });
};

export const getDetailContent = (detail, objToRender, fallback = '--') => {
  return detail?.getValue?.(objToRender) ?? fallback;
};
